exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea{resize:none;overflow:hidden;box-shadow:inset 0 0 0 rgb(10 10 10/10%)}.inputP{height:50px!important;font-size:40px!important;width:100%!important;padding-left:0!important;box-shadow:inset 0 0 0 rgb(10 10 10/10%)!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4c9ad9ec","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modals/ModalConsentimiento.vue
// module id = 784
// module chunks = 2